// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}
.box_qest {
  display: flex;
  flex-direction: row;
  margin-top: 5px;
}

.box {
  width: 15.5%;
  height: 100px;
  margin: 5px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.86);
  padding-left: 10px;
  text-align: left;
  background-color:  rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 5px;
  font-size: 8px;
}
/* For Webkit browsers (Chrome, Safari) */
::-webkit-scrollbar {
  width: 5px; /* Width of the scrollbar */
}

::-webkit-scrollbar-track {
  background: transparent; /* Make the track (the background of the scrollbar) transparent */
}

::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2); /* Color of the scrollbar thumb (the part you can drag), with some transparency */
  border-radius: 10px; /* Round the corners */
  border: 3px solid transparent; /* Make sure the thumb is not too thin */
}



.metdata-accordian-ria {
 
  border-radius: 20px !important;
 font-size: 12 !important;
  background-color: rgb(43, 44, 51);
  border: 1px solid rgb(78, 78, 78);
  color:  rgba(155, 156, 158, 1)
}

.metdata-accordian-ria .accordion-body {
  background-color: rgb(43, 44, 51);
  font-size: 12 !important;
  color: rgba(155, 156, 158, 1);
  overflow-y: scroll;
  max-height: 360px;
  border: 1px solid rgb(78, 78, 78);
}

.accordion-item {
  background-color: rgb(43, 44, 51);
  font-size: 12 !important;
  color:  rgba(155, 156, 158, 1);
  border: 1px solid rgb(78, 78, 78);
}
.custom-accordion-header-sop {
  font-size: 10px !important;
}

.accordion-button.collapsed {
  background-color: rgb(43, 44, 51);
  color:  rgba(155, 156, 158, 1);
  font-size: 12 !important;
  height: 30px;
  border: 1px solid rgb(78, 78, 78);
}

.accordion-button:not(.collapsed) {
  background-color: rgb(43, 44, 51) !important;
  color:  rgba(155, 156, 158, 1) !important;
  height: 30px;
  border: 1px solid rgb(78, 78, 78) !important;
}
.panel-heading a:not(.collapsed) {
  background-color: rgb(43, 44, 51);
  color:  rgba(155, 156, 158, 1);
  border: 1px solid rgb(78, 78, 78);
  border-bottom: 1px solid red;
 
}

.accordion-button.collapsed::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

/* .accordion-button.collapsed::before {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
} */

.accordion-button:not(.collapsed)::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.sop-file-upload {
 
  font-family: Arial, sans-serif;
  /* overflow: hidden; */
  margin-right: 5px;
 
  /* margin-left: 78%; */
  padding-bottom: 5px;
}

.sop-file-upload input[type="file"] {
  font-size: 0px;
 
  left: 0;
  top: 0;
  opacity: 0;
}

.sop-file-upload span {
  padding: 6px 4px 8px 0px;
  cursor: pointer;
  
  /* width:100px; */
  /* height:20px; */
  /* margin-left: 60px; */
  /* background-color: rgba(116, 123, 169, 0.3); */
}
.gradient-text {
  font-size: 35px; /* Adjust the font size as needed */
  font-weight: 700; /* Optional: Make the text bold */
  background: linear-gradient(to right, rgba(246, 106, 75, 1) 0%, rgba(246, 106, 75, 1) 30%, rgba(162, 74, 231, 1) 60%, rgba(72, 89, 243, 1) 100%);
  -webkit-background-clip: text;
 
  line-height: 48px;
  font-family: 'Graphik';
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-align: center;
  color: transparent;
}
/* Add these styles in your CSS file */
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none; /* Allows interaction with background elements */
  z-index: 1000;
  background: transparent; /* Remove background shadow */
}

.popup-container {
  position: absolute;
  background:rgba(19, 22, 25, 1);
  border-radius: 8px;
  padding: 10px;
  cursor: move;
  z-index: 1001;
  pointer-events: auto; /* Allows interaction with the popup */
}

.pdf-viewer {
  width: 41vw;
  height: 76vh;
  margin-top: 1%;
}

.close-button {
  position: absolute;
  top: 5px;
  right: 5px;
  background: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
  z-index: 1002; /* Ensure the close button stays on top */
}

.hstack {
  display: flex;
  flex-direction: row;
  align-items:normal !important; 
  align-self: stretch;
}
.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  /* margin-top: calc(-1* var(--bs-gutter-y)); */
  margin-right: 0px !important;
  margin-left: calc(-.5* var(--bs-gutter-x));
}
.box:hover {
 border: 1px solid white;
}

.box.selected {
  border: 1px solid white;
}
.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App1.css"],"names":[],"mappings":";;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;EAC5C,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;AAChB;AACA,yCAAyC;AACzC;EACE,UAAU,EAAE,2BAA2B;AACzC;;AAEA;EACE,uBAAuB,EAAE,iEAAiE;AAC5F;;AAEA;EACE,oCAAoC,EAAE,iFAAiF;EACvH,mBAAmB,EAAE,sBAAsB;EAC3C,6BAA6B,EAAE,wCAAwC;AACzE;;;;AAIA;;EAEE,8BAA8B;CAC/B,wBAAwB;EACvB,iCAAiC;EACjC,iCAAiC;EACjC;AACF;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;EACxB,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;EACxB,8BAA8B;EAC9B,iCAAiC;AACnC;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,wBAAwB;EACxB,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,4CAA4C;EAC5C,yCAAyC;EACzC,YAAY;EACZ,4CAA4C;AAC9C;AACA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,iCAAiC;EACjC,4BAA4B;;AAE9B;;AAEA;EACE,yDAA8R;AAChS;;AAEA;;GAEG;;AAEH;EACE,yDAA8R;AAChS;AACA;;EAEE,8BAA8B;EAC9B,sBAAsB;EACtB,iBAAiB;;EAEjB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;;EAEd,OAAO;EACP,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,eAAe;;EAEf,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;EACvB,gDAAgD;AAClD;AACA;EACE,eAAe,EAAE,mCAAmC;EACpD,gBAAgB,EAAE,iCAAiC;EACnD,gJAAgJ;EAChJ,6BAA6B;;EAE7B,iBAAiB;EACjB,sBAAsB;EACtB,oCAAoC;EACpC,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;AACA,sCAAsC;AACtC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB,EAAE,gDAAgD;EACtE,aAAa;EACb,uBAAuB,EAAE,6BAA6B;AACxD;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,oBAAoB,EAAE,sCAAsC;AAC9D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa,EAAE,yCAAyC;AAC1D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,8CAA8C;EAC9C,4BAA4B;EAC5B,0CAA0C;AAC5C;AACA;CACC,uBAAuB;AACxB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n.box_qest {\n  display: flex;\n  flex-direction: row;\n  margin-top: 5px;\n}\n\n.box {\n  width: 15.5%;\n  height: 100px;\n  margin: 5px;\n  display: flex;\n  flex-direction: column;\n  cursor: pointer;\n  color: rgba(255, 255, 255, 0.86);\n  padding-left: 10px;\n  text-align: left;\n  background-color:  rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 5px;\n  font-size: 8px;\n}\n/* For Webkit browsers (Chrome, Safari) */\n::-webkit-scrollbar {\n  width: 5px; /* Width of the scrollbar */\n}\n\n::-webkit-scrollbar-track {\n  background: transparent; /* Make the track (the background of the scrollbar) transparent */\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: rgba(0, 0, 0, 0.2); /* Color of the scrollbar thumb (the part you can drag), with some transparency */\n  border-radius: 10px; /* Round the corners */\n  border: 3px solid transparent; /* Make sure the thumb is not too thin */\n}\n\n\n\n.metdata-accordian-ria {\n \n  border-radius: 20px !important;\n font-size: 12 !important;\n  background-color: rgb(43, 44, 51);\n  border: 1px solid rgb(78, 78, 78);\n  color:  rgba(155, 156, 158, 1)\n}\n\n.metdata-accordian-ria .accordion-body {\n  background-color: rgb(43, 44, 51);\n  font-size: 12 !important;\n  color: rgba(155, 156, 158, 1);\n  overflow-y: scroll;\n  max-height: 360px;\n  border: 1px solid rgb(78, 78, 78);\n}\n\n.accordion-item {\n  background-color: rgb(43, 44, 51);\n  font-size: 12 !important;\n  color:  rgba(155, 156, 158, 1);\n  border: 1px solid rgb(78, 78, 78);\n}\n.custom-accordion-header-sop {\n  font-size: 10px !important;\n}\n\n.accordion-button.collapsed {\n  background-color: rgb(43, 44, 51);\n  color:  rgba(155, 156, 158, 1);\n  font-size: 12 !important;\n  height: 30px;\n  border: 1px solid rgb(78, 78, 78);\n}\n\n.accordion-button:not(.collapsed) {\n  background-color: rgb(43, 44, 51) !important;\n  color:  rgba(155, 156, 158, 1) !important;\n  height: 30px;\n  border: 1px solid rgb(78, 78, 78) !important;\n}\n.panel-heading a:not(.collapsed) {\n  background-color: rgb(43, 44, 51);\n  color:  rgba(155, 156, 158, 1);\n  border: 1px solid rgb(78, 78, 78);\n  border-bottom: 1px solid red;\n \n}\n\n.accordion-button.collapsed::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n}\n\n/* .accordion-button.collapsed::before {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n} */\n\n.accordion-button:not(.collapsed)::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n}\n.sop-file-upload {\n \n  font-family: Arial, sans-serif;\n  /* overflow: hidden; */\n  margin-right: 5px;\n \n  /* margin-left: 78%; */\n  padding-bottom: 5px;\n}\n\n.sop-file-upload input[type=\"file\"] {\n  font-size: 0px;\n \n  left: 0;\n  top: 0;\n  opacity: 0;\n}\n\n.sop-file-upload span {\n  padding: 6px 4px 8px 0px;\n  cursor: pointer;\n  \n  /* width:100px; */\n  /* height:20px; */\n  /* margin-left: 60px; */\n  /* background-color: rgba(116, 123, 169, 0.3); */\n}\n.gradient-text {\n  font-size: 35px; /* Adjust the font size as needed */\n  font-weight: 700; /* Optional: Make the text bold */\n  background: linear-gradient(to right, rgba(246, 106, 75, 1) 0%, rgba(246, 106, 75, 1) 30%, rgba(162, 74, 231, 1) 60%, rgba(72, 89, 243, 1) 100%);\n  -webkit-background-clip: text;\n \n  line-height: 48px;\n  font-family: 'Graphik';\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  text-align: center;\n  color: transparent;\n}\n/* Add these styles in your CSS file */\n.popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none; /* Allows interaction with background elements */\n  z-index: 1000;\n  background: transparent; /* Remove background shadow */\n}\n\n.popup-container {\n  position: absolute;\n  background:rgba(19, 22, 25, 1);\n  border-radius: 8px;\n  padding: 10px;\n  cursor: move;\n  z-index: 1001;\n  pointer-events: auto; /* Allows interaction with the popup */\n}\n\n.pdf-viewer {\n  width: 41vw;\n  height: 76vh;\n  margin-top: 1%;\n}\n\n.close-button {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  background: transparent;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  z-index: 1002; /* Ensure the close button stays on top */\n}\n\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items:normal !important; \n  align-self: stretch;\n}\n.row {\n  --bs-gutter-x: 1.5rem;\n  --bs-gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  /* margin-top: calc(-1* var(--bs-gutter-y)); */\n  margin-right: 0px !important;\n  margin-left: calc(-.5* var(--bs-gutter-x));\n}\n.box:hover {\n border: 1px solid white;\n}\n\n.box.selected {\n  border: 1px solid white;\n}\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
